export default "__VITE_ASSET__BzZVgYuy__"